    <div class="modal-header">
        <h4 class="modal-title" id="modal-title">{{confirmModalInfo.title}}</h4>
        <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
            (click)="activeModal.close(false)"></button>
    </div>
    <div class="modal-body">
        <p>
            <strong>{{confirmModalInfo.subTitle}}</strong>
        </p>
        <p>
            {{confirmModalInfo.message}}
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">Cancel</button>
        <button type="button" ngbAutofocus class="btn btn-danger" (click)="activeModal.close(true)">Ok</button>
    </div>